<template>
	<div v-if="!error" class="u-colorReverse">
		<span v-if="loadingStatus" class="u-text-3">{{ loading }}</span>
		<a v-if="status" :href="url" v-clo-tooltip :title="tooltipText">
				<span class="Badge u-inline-xs" :class="constatusClass(status)">
					<span class="Badge-label">{{ status }}</span>
				</span>
				{{ constatusText(status) }}
		</a>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'ConservationStatus',
	props: {
		speciesCode: {
			type: String,
			required: true,
		},
		lc: {
			type: String,
			required: true,
		},
		nt: {
			type: String,
			required: true,
		},
		vu: {
			type: String,
			required: true,
		},
		en: {
			type: String,
			required: true,
		},
		cr: {
			type: String,
			required: true,
		},
		ew: {
			type: String,
			required: true,
		},
		ex: {
			type: String,
			required: true,
		},
		ne: {
			type: String,
			required: true,
		},
		dd: {
			type: String,
			required: true,
		},
		loading: {
			type: String,
			required: true,
		},
		credit: {
			type: String,
			required: true,
		},
		apiUrl: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			loadingStatus: true,
			error: false,
			status: null,
			url: '',
			tooltipText: '',
		};
	},
	mounted() {
		axios
			.get(this.apiUrl.replace('{0}', this.speciesCode))
			.then((res) => {
				this.loadingStatus = false;
				// res.data is an array of conservation statuses, such as CITES and IUCN
				if (res.data.length) {
					const iucn = res.data.find((item) => {
						return item.fieldName === 'IUCN_status';
					});
					if (iucn) {
						// value has the status code
						// auxCode has the ID for the BirdLife URL
						this.status = iucn.value.replace('IUCN_', '');
						this.url = 'https://datazone.birdlife.org/species/factsheet/' + iucn.auxCode;
						// year is the last 4 digits of the comments
						const year = iucn.comment.slice(-4);
						this.tooltipText = this.credit.replace('{0}', year);

					} else {
						this.error = true;
					}
				} else {
					this.error = true;
				}
			})
			.catch((err) => {
				this.error = true;
			});
	},
	methods: {
		constatusClass(status) {
			return 'u-color-constatus-' + status.toLowerCase();
		},
		constatusText(status) {
			return this[status.toLowerCase()];
		},
	},
}
</script>
